var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":_vm.$attrs.variant,"disabled":_vm.$attrs.disabled,"size":_vm.$attrs.size},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.isProcessing)?_vm._t("default"):_c('span',[_c('i',{class:['fa', _vm.selectedIcon, 'fa-spin']}),_vm._v(" "+_vm._s(_vm.busyLabel)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }